<script>
  import { _ } from 'svelte-i18n'
  import { slide } from 'svelte/transition';

  import LargerPill from '/Atoms/LargerPill'
  import IconInfo from '/Icons/IconInfo'
  import IconAlmanacToggle from '/Icons/IconAlmanacToggle'
  import IconFilter from '/Icons/IconPlus'
  import IconClose from '/Icons/IconClose'

  import AlmanacGrid from '/Groups/AlmanacGrid'
  import AlmanacList from '/Groups/AlmanacList'
  import TemplateAlmanacAbout from '/Templates/TemplateAlmanacAbout'

  export let data, listview, infoview

  let filterActive = false
  let activeTags = []

  const now = new Date()

  const widgets = (data?.entries?.[0]?.relatedWidgets || [])
    // add "collectionType" category to all of type "collection"
    .map(w => {
      if (w?.linkedContent?.[0]?.typeHandle === "collection" && !w?.linkedContent?.[0]?.textMediaCategory) {
        const newLinkedContent = { ...w.linkedContent[0] }
        newLinkedContent.textMediaCategory = newLinkedContent.collectionType?.[0] || $_("widgets.category.collection")
        return {
          ...w,
          linkedContent: [newLinkedContent, ...w.linkedContent.slice(1)]
        }
      }
      return w
    })

  let filteredWidgets = widgets

  const widgetDates = widgets.map( w => {
    const wDate = new Date(w.postDate)
    const wYear = wDate.getUTCFullYear()
    const wMonth = wDate.getUTCMonth()
    return {
      wYear,
      wMonth
    }
  })

  // filter tags for data: create manually
  let filterTagsDate = [
    {year: 2021, month:  0, title: $_("months.abbr.Jan")},
    {year: 2021, month:  1, title: $_("months.abbr.Feb")},
    {year: 2021, month:  2, title: $_("months.abbr.Mar")},
    {year: 2021, month:  3, title: $_("months.abbr.Apr")},
    {year: 2021, month:  4, title: $_("months.abbr.May")},
    {year: 2021, month:  5, title: $_("months.abbr.Jun")},
    {year: 2021, month:  6, title: $_("months.abbr.Jul")},
    {year: 2021, month:  7, title: $_("months.abbr.Aug")},
    {year: 2021, month:  8, title: $_("months.abbr.Sep")},
    {year: 2021, month:  9, title: $_("months.abbr.Oct")},
    {year: 2021, month: 10, title: $_("months.abbr.Nov")},
    {year: 2021, month: 11, title: $_("months.abbr.Dec")},
    {year: 2022, month:  0, title: $_("months.abbr.Jan")},
    {year: 2022, month:  1, title: $_("months.abbr.Feb")},
    {year: 2022, month:  2, title: $_("months.abbr.Mar")},
  ].map(t => ({
    ...t,
    available: widgetDates.findIndex(w => t.year === w.wYear && t.month === w.wMonth) > -1
  }))
  .map(t => ({ ...t, active: false, id: t.year+"/"+t.month }))

  // filter tags for format: get unique textMediaCategory of linkedContent widgets
  let filterTagsFormat = [
      // make unique
      ...new Set(widgets.map(w =>
        // get textMediaCategory of linkedContent
        w?.linkedContent?.[0]?.textMediaCategory
      )
      // remove entries without textMediaCategory
      .filter(format => format !== undefined))
    ]
    // add meta attributes
    .map(t => ({ id: t, title: t, active: false }))

  // filter tags for programme: get from prefixed tags
  let filterTagsProgramme = [
    // make unique
    ...new Set(widgets
      // get the titles of the tags
      .map(w => (w.tags || []).map(t => t.title))
      // flatten array
      .reduce((acc, val) => acc.concat(val), [])
      // filter by prefix
      .filter(t => t.toLowerCase().indexOf("programme:") === 0)
      // extract what comes after the prefix
      .map(t => t.substr(10))
      // trim
      .map(t => t.trim()
    )
  )]
  // add meta attributes
  .map(t => ({ id: t, title: t, active: false }))

  const toggleTagFormat = (tag) => {
    const i = filterTagsFormat.findIndex(t => t.id === tag.id)
    filterTagsFormat[i].active = !filterTagsFormat[i].active
    filterTagsFormat[i].activatedAt = Date.now()
  }

  const toggleTagProgramme = (tag) => {
    const i = filterTagsProgramme.findIndex(t => t.id === tag.id)
    filterTagsProgramme[i].active = !filterTagsProgramme[i].active
    filterTagsProgramme[i].activatedAt = Date.now()
  }

  const toggleTagDate = (tag) => {
    const i = filterTagsDate.findIndex(t => t.id === tag.id)
    filterTagsDate[i].active = !filterTagsDate[i].active
    filterTagsDate[i].activatedAt = Date.now()
  }

  const clearFilters = () => {
    filterTagsDate = filterTagsDate.map(w => ({...w, active: false}))
    filterTagsFormat = filterTagsFormat.map(w => ({...w, active: false}))
    filterTagsProgramme = filterTagsProgramme.map(w => ({...w, active: false}))
  }

  const clearTag = (tag) => {
    filterTagsDate = filterTagsDate.map(w => ({...w, active: w.activatedAt === tag.activatedAt ? false : w.active}))
    filterTagsFormat = filterTagsFormat.map(w => ({...w, active: w.activatedAt === tag.activatedAt ? false : w.active}))
    filterTagsProgramme = filterTagsProgramme.map(w => ({...w, active: w.activatedAt === tag.activatedAt ? false : w.active}))
  }

  //console.log(
  //  widgets,
  //  filterTagsDate,
  //  filterTagsFormat,
  //  filterTagsProgramme
  //)

  $: {
    // apply filters
    // filters of same type are applied as OR
    // filters of different type are applied as AND
    // example: may, june, video => (may OR june) AND video
    filteredWidgets = widgets

    // apply date filter
    if (filterTagsDate.filter(t => t.active).length > 0) {
      filteredWidgets = filteredWidgets.filter(w => {
        const wDate = new Date(w.postDate)
        const wYear = wDate.getUTCFullYear()
        const wMonth = wDate.getUTCMonth()
        for ( let tag of filterTagsDate ) {
          if (tag.active && tag.year === wYear && tag.month === wMonth) return true
        }
        return false
      })
      //console.log(filteredWidgets)
    }

    // apply format filter
    if (filterTagsFormat.filter(t => t.active).length > 0) {
      filteredWidgets = filteredWidgets.filter(w => {
        const wFormat = w?.linkedContent?.[0]?.textMediaCategory
        for ( let tag of filterTagsFormat ) {
          if (tag.active && tag.title === wFormat) return true
        }
        return false
      })
      //console.log(filteredWidgets)
    }

    // apply Programme filter
    if (filterTagsProgramme.filter(t => t.active).length > 0) {
      filteredWidgets = filteredWidgets.filter(w => {
        const wProgrammes = (w?.tags || []).map( t => (t?.title || "").substr(10).trim() )
        for ( let tag of filterTagsProgramme ) {
          if (tag.active && wProgrammes.indexOf(tag.title) > -1 ) return true
        }
        return false
      })
      console.log(widgets, filteredWidgets)
    }

    // make a list of active tags
    activeTags = [...filterTagsDate, ...filterTagsFormat, ...filterTagsProgramme]
      .filter(t => t.active)
      .sort( (a,b) => a.activatedAt - b.activatedAt)

  }

</script>

<section>

  <h1>
    Almanac
  </h1>

  <nav class="pillnav">

    <div class="pill">
      <LargerPill link={infoview ? "/almanac" : "/almanac/almanac-info"} >
        <span class="aboutButton">
          {#if infoview}
            <IconInfo inline open /> {$_('almanac.buttons.about')}
          {:else}
            <IconInfo inline  /> {$_('almanac.buttons.about')}
          {/if}
        </span>
      </LargerPill>
    </div>

    {#if !infoview}

    <div class="pill">
      <LargerPill link={listview ? "/almanac" : "/almanac/list" } >
        <span class="toggleButton">
          {#if listview}
            <IconAlmanacToggle /> {$_('almanac.buttons.overview')}
          {:else}
            <IconAlmanacToggle list /> {$_('almanac.buttons.list')}
          {/if}
        </span>
      </LargerPill>
    </div>

    <div class="pill">
      <LargerPill hover on:click={() => (filterActive = !filterActive)} >
        <span class="filterButton">
          {#if filterActive}
            <span style="font-size:21px; position: relative; top: 2px;">
              <IconClose beige inline />
            </span>
          {:else}
            <IconFilter inline />
          {/if}
          Filter
        </span>
      </LargerPill>
    </div>

    {#each activeTags as tag}
      <div class="pill activeTags">
        <LargerPill hover almanac on:click={() => clearTag(tag)} >
          <span class="tagButton">
            <span class="icon close">
              <IconClose inline red />
            </span>
            {tag.title}
          </span>
        </LargerPill>
      </div>
    {/each}

    {#if activeTags.length > 0}
      <div class="pill">
        <LargerPill hover almanac on:click={clearFilters}>
          <span class="clearButton">
            <span class="icon close">
              <IconClose inline red />
            </span>
            {$_("almanac.filter.clear")}
          </span>
        </LargerPill>
      </div>
    {/if}

    {/if}

  </nav>

  {#if !infoview}

  {#if filterActive}
    <div transition:slide|local class="filterPanel">

      <div class="filterDate">
        <h2 class="filterTitle">
          {$_("almanac.filter.date")}
        </h2>
        <div class="calendar">
          {#each filterTagsDate as tag}
            {#if tag.month === 0}
              <h3 class="year">
                {tag.year}
              </h3>
            {/if}
            <span class="month list">
              <span class="listItem" class:active={tag.active} class:disabled={!tag.available} on:click={() => toggleTagDate(tag)}>
                {#if tag.active}
                  <span class="icon">
                    <IconClose inline red />
                  </span>
                {/if}
                {tag.title}
              </span>
            </span>
          {/each}
        </div>
      </div>
      <div class="filterFormat">
        <h2 class="filterTitle">
          {$_("almanac.filter.format")}
        </h2>

        <ul class="formatsList">
          {#each filterTagsFormat as tag}
            <li class="listItem" class:active={tag.active} on:click={() => toggleTagFormat(tag)}>
              <LargerPill hover almanac>
                {#if tag.active}
                  <span class="icon">
                    <IconClose inline red />
                  </span>
                {/if}
                <span class="tagTitle">
                  {tag.title}
                </span>
              </LargerPill>
            </li>
          {/each}
        </ul>
      </div>

      <div class="filterProgramme">
        <h2 class="filterTitle">
          {$_("almanac.filter.programme")}
        </h2>
        <ul class="programmeList">
          {#each filterTagsProgramme as tag}
            <li class="listItem" class:active={tag.active} on:click={() => toggleTagProgramme(tag)}>
              {#if tag.active}
                <span class="icon">
                  <IconClose inline red />
                </span>
              {/if}
              <span class="tagTitle">
                {tag.title}
              </span>
            </li>
          {/each}
        </ul>
      </div>
    </div>
  {/if}

  {#key filteredWidgets}
    {#if listview}
      <AlmanacList widgets={filteredWidgets.filter(w => w?.typeHandle === "contentWidget")} />
    {:else}
        <AlmanacGrid widgets={filteredWidgets} />
    {/if}
  {/key}

  {:else}

  <TemplateAlmanacAbout data={data.about} />

  {/if}

</section>

<style lang="scss">

  section {
    box-sizing: border-box;
    /* min-height: 100vh; */
  }

  .pillnav {
    color: $color-beige;
    padding-left: $grid-gap-large;
    padding-bottom: $grid-gap-large;
    @include media-small {
      padding-left: $grid-gap-small;
      padding-bottom: $grid-gap-small;
    }
    margin-bottom: -12px;

    .pill {
      display: inline-flex;
      margin: 0 4px 12px 0;
      &.activeTags {
        @include media-small {
          display: none;
        }
      }
    }

    .aboutButton, .toggleButton, .filterButton, .tagButton, .clearButton {
      display: inline-block;
      padding: .3ex .8ex 0 0;
    }

    .tagButton, .clearButton {
      color: $color-red;
      .icon {
        position: relative;
        top: 0.8em;
      }
    }
    .toggleButton {
      padding-left: .5ex;
    }

    .icon.close {
      position: relative;
      top: 0.2em;
    }

  }

  h1 {
    @include grid-padding;
    @include grotesk-stack;

    font-size: 22vw;
    line-height: 22vw;
    @include media-1col-only {
      font-size: 22.8vw; // ~100% of width inside padding
    }
    @include media-2col {
      font-size: 17.5vw; // ~75% of width inside padding
      line-height: 16vw;
    }
    @include media-4col {
      font-size: 231px;
      line-height: 231px;
      text-align: center;
    }
    color: $color-red;
    margin-bottom: -0.08em;

    padding-top: #{ 0.85 * $frame-top-large };
    @include media-small {
      padding-top: #{ 0.88 * $frame-top-small };
    }
  }

  .filterPanel {
    @include grid-padding;
    margin: 0 0 28px 0;
    /* @include media-small {
      margin-bottom: 70px;
    } */
    display: flex;
    flex-direction: row;
    align-content: stretch;
    * {user-select: none;}
    > * {
      width: 33.3333%;
      @include media-small {
        width: 100%;
      }
    }
    @include media-small {
      flex-direction: column;
    }
    .filterTitle {
      @include typo-grotesk-text-24-small;
      margin-top: 1em;
      margin-bottom: 1em;
      color: $color-red;
      @include media-small {
        padding-top: 1.5em;
        margin-bottom: 1.25em;
      }
    }
    @include media-large-only {
      .filterFormat {
        padding: 0 20px;
      }
    }
  }

  .calendar {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow: hidden;
    border: solid 2px $color-red;
    @include typo-serif-small-caps-28-small;
    line-height: 30px;
    border-radius: 20px;
    @include media-small {
      border-radius: 15px;
    }

    .year {
      flex: 100%;
      padding-bottom: 2px;
      text-align: center;
      background-color: $color-red;
      color: $color-beige;
    }
    .month {
      flex: 33.3333333%;
      text-align: center;
      box-sizing: border-box;
      border: solid 2px $color-red;
      border-width: 0;
      &:nth-of-type(3n-1) {
        border-width: 0 2px;
      }
      &:nth-of-type(1),
        &:nth-of-type(1),
        &:nth-of-type(2),
        &:nth-of-type(3),
        &:nth-of-type(4),
        &:nth-of-type(5),
        &:nth-of-type(6),
        &:nth-of-type(7),
        &:nth-of-type(8),
        &:nth-of-type(9) {
        border-bottom-width: 2px;
      }

      .icon {
        position: relative;
        top: 0.3em;
      }
    }
  }

  .filterFormat {
    margin-bottom: -12px;
    .listItem {
      display: inline-flex;
      margin: 0 8px 12px 0;
    }
    .icon {
      position: relative;
      top: 0.2em;
    }
  }

  .filterProgramme {
    .listItem {
      @include typo-serif-small-caps-28-small;
      padding: 2px 0 5px 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      user-select: none;

      border-top: solid 2px $color-red;
      &:last-child {
        border-bottom: solid 2px $color-red;
      }


      .icon {
        display: inline-block;
        margin: 0 0 -0.3em -0.1em;
        height: 1em;
        overflow: hidden;
      }
    }
  }

  .listItem {
    cursor: pointer;
    &.disabled {
      opacity: .5;
      pointer-events: none;
    }
    &.active, &.active .tagTitle {
      color: $color-red;
    }
  }
  .calendar .listItem:hover,
  .programmeList .listItem:hover .icon,
  .programmeList .listItem:hover .tagTitle {
    text-shadow: $color-mint 0 0 10px;
    filter: drop-shadow($color-mint 0 0 5px);
  }
</style>